<script setup>
import { defineProps, defineModel, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
    label: String,
    options: {
        type: Array,
        required: true,
    },
    rules: {
        type: Array,
        default: () => []
    },
    readonly: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    inline: {
        type: Boolean,
        default: true
    },
    value: {
        type: String,
    }
})

const model = defineModel()

onMounted(async () => {
    const defaultOption = props.options?.find(o => o.default === true) || props.options?.find(o => o.default === true)
    if (!model.value && defaultOption) {
        model.value = defaultOption.value
    }
})

const requiredRule = (v) =>
    !!v || t('common.messages.validations.required')

const combinedRules = computed(() => {
    const rules = [...props.rules]
    if (props.required) rules.unshift(requiredRule)
    return rules
})

</script>

<template>
    <div class="radio-group" >
        <v-radio-group
            v-model="model"
            :rules="combinedRules"
            :readonly="readonly"
            :inline="inline"
            density="comfortable"
        >
            <v-radio
                v-for="(option, index) in options"
                :key="index"
                :label="t(option.label)"
                :value="option.value"
                :disabled="readonly"
            />
        </v-radio-group>
    </div>
</template>
